import React from "react";
import { NavLink } from "react-router-dom";

import Main from "../layouts/Main";

import PageBanner from "../components/PageBanner";

const Services = () => (
  <Main>
    <PageBanner title="Current International Student" />
    <section className="ls s-py-60 s-py-md-90 s-py-xl-120 single-service  c-gutter-60">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <article className="vertical-item content-padding type-event status-publish format-standard has-post-thumbnail">
              <div className="item-media">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/img1.jpg`}
                  alt=""
                />
              </div>
              <div className="item-content pl-0 pr-0 pb-0">
                <div className="entry-content">
                  <p className="excerpt">
                    Are you an international student looking for an internship
                    or a full-time job in the US? Or do you need general career
                    advice? We were in your shoes only a few years ago and will
                    be glad to help you.
                  </p>
                  <p className="excerpt">This service includes:</p>

                  <ul>
                    <li>Resume review</li>
                    <li>Job interview preparation</li>
                    <li>Connecting you with a mentor</li>
                    <li>
                      Providing you with advice on career path post-graduation
                    </li>
                    <li>Connecting you with immigration lawyers if needed</li>
                    <li>
                      Integrating you into our community of working
                      professionals
                    </li>
                  </ul>
                </div>
                <br />
                <br />
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSdSxtJYcmf-c0ABnq7iXycpqx8KgaEiznxPr93axFI_u_VHqQ/viewform?vc=0&c=0&w=1&flr=0&gxids=7757"
                  target="_blank"
                  className="btn btn-small btn-maincolor"
                >
                  Schedule a Consultation
                </a>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  </Main>
);

export default Services;
